import { loggingApiClient } from '@/lib/api-client'

export interface LogEntry {
  level: 'error' | 'warn' | 'info' | 'debug'
  message?: string
  category?: 'api' | 'activity' | 'client_error'
  error?: string | null
  route?: string
  method?: string
  responseTime?: string
  statusCode?: number
  ip?: string
  user?: {
    dealerId?: string
    employeeId?: string
  }
  [key: string]: unknown
}

export interface LogResponse {
  success: boolean
  message?: string
  [key: string]: unknown
}

/**
 * Upload log entry to the server
 * @param logEntry - The log entry to upload
 * @returns Log response from the server
 */
export const uploadLog = async (logEntry: LogEntry): Promise<LogResponse> => {
  const response = await loggingApiClient.post<LogResponse>(
    `${import.meta.env.VITE_URL_PATH || '/internal/readywire-bulk'}/json-storage/upload`,
    logEntry
  )
  return response.data
}
